export default __webpack_public_path__ + "static/media/Transactions.7ac2823a.svg";